export const styles = {
	notificationText: {
		fontWeight: "bold",
		color: "#666666",
		textAlign: "center",
		padding: "0.5rem",
	},
};
